export const LabelOverrides = {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '19px',
    paddingTop: '36px',
    paddingLeft: '36px',
    paddingBottom: '29px',
    fontFamily: '"Inter",sans-serif'
};
